import { useState } from "react";

/**
 * Mental health role entry.
 * Styled to match Home sections (services / mentoring):
 * subsection label, compact meta line, disc list body.
 */
const MentalHealthCard = ({
  organisation,
  role,
  duration,
  jobscope = [],
  showOrganisation = false,
  collapsibleAllViewports = false,
  alwaysExpanded = false,
  organisationHeading: OrganisationHeading = "h3",
}) => {
  const [open, setOpen] = useState(false);
  const hasJobScope = jobscope.length > 0;
  const showToggle = hasJobScope && !alwaysExpanded;

  return (
    <div className="mt-4 first:mt-0">
      {showOrganisation && (
        <OrganisationHeading className="text-base font-semibold text-lightText dark:text-darkText">
          {organisation}
        </OrganisationHeading>
      )}

      <div className={showOrganisation ? "mt-1.5" : "mt-3"}>
        <div className="flex items-start justify-between gap-3">
          <p className="min-w-0 text-sm font-medium leading-snug text-gray-700 dark:text-gray-300">
            {role}
            {duration ? (
              <span className="font-normal text-gray-500 dark:text-gray-400">
                {" · "}
                {duration}
              </span>
            ) : null}
          </p>

          {showToggle && (
            <button
              type="button"
              onClick={() => {
                if (collapsibleAllViewports || window.innerWidth < 1024) {
                  setOpen((prev) => !prev);
                }
              }}
              className={`shrink-0 text-sm font-medium text-green dark:text-green-dark underline underline-offset-2 ${
                collapsibleAllViewports ? "" : "lg:hidden"
              }`}
              aria-expanded={open}
            >
              {open ? "Less" : "More"}
            </button>
          )}
        </div>

        {hasJobScope && (
          <ul
            className={`mt-1.5 list-disc space-y-1 pl-4 text-sm leading-relaxed text-gray-700 dark:text-gray-300 [&_a]:text-green dark:[&_a]:text-green-dark [&_a]:underline [&_a]:underline-offset-2 ${
              alwaysExpanded
                ? "block"
                : collapsibleAllViewports
                  ? open
                    ? "block"
                    : "hidden"
                  : `${open ? "block" : "hidden"} lg:block`
            }`}
          >
            {jobscope.map((item, idx) => (
              <li key={idx}>
                {item.description.includes("<a") ? (
                  <span
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  />
                ) : (
                  item.description
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default MentalHealthCard;
